const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const monthsOfYear = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const getDateForOverview = (date) => {
    if (!date || !(date instanceof Date)) {
      return "Invalid date";
    }
    const dayOfWeek = daysOfWeek[date.getDay()];
    const dayOfMonth = date.getDate();
    const month = monthsOfYear[date.getMonth()];
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';

    // Convert hours to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // '0' should be '12' in 12-hour format

    const lastUpdatedTime = `${dayOfWeek} ${dayOfMonth} ${month} ${year} ${hours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
    return lastUpdatedTime;
}

export const getDateForMarketClose = (date) => {
    if (!date || !(date instanceof Date)) {
      return "Invalid date";
    }
    const dayOfWeek = daysOfWeek[date.getDay()];
    const dayOfMonth = date.getDate();
    const month = monthsOfYear[date.getMonth()];
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'p.m' : 'a.m';
    hours = hours % 12;
    hours = hours ? hours : 12; // '0' should be '12' in 12-hour format

    const lastUpdatedTime = `${dayOfWeek} ${dayOfMonth} ${month} ${year} ${hours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
    return lastUpdatedTime;
}

export const getDateForTooltip = (date) => {
    const dayOfMonth = date.getDate();
    const month = monthsOfYear[date.getMonth()];
    const year = date.getFullYear();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'p.m' : 'a.m';
    hours = hours % 12;
    hours = hours ? hours : 12; // '0' should be '12' in 12-hour format
    minutes = minutes < 10 ? '0' + minutes : minutes.toString();
    return `${dayOfMonth} ${month} ${year} \n ${hours}:${minutes} ${ampm}`;
}

export const quarterFormat = (qtr) => {
    const date = new Date(qtr);
    const month = date.getMonth();
    const year = date.getFullYear();
    let quarter;

    if (month >= 0 && month <= 2) {
        quarter = 'Q1';
    } else if (month >= 3 && month <= 5) {
        quarter = 'Q2';
    } else if (month >= 6 && month <= 8) {
        quarter = 'Q3';
    } else {
        quarter = 'Q4';
    }

    return `${quarter} ${year}`;
};
